import { produce } from 'immer';

import { InitCampaignPlaceEditors } from '../../actions/campaignPlaceEditor/initCampaignPlaceEditors';
import { CampaignPlaceEditorState } from '../../typings/campaignPlaceEditor';

export function initCampaignPlaceEditors(
    state: CampaignPlaceEditorState,
    action: InitCampaignPlaceEditors
): CampaignPlaceEditorState {
    return produce(state, draft => {
        const { payload } = action;

        payload.forEach(({ editorId, place: { pageId, placeId } }) => {
            draft[editorId] = {
                pageId,
                placeId,
                isOpen: true,
                errors: []
            };
        });
    });
}
